import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'
import { ResetPassword } from '@pages/auth/reset-password-page';
import { ForgetPasswordPage } from '@pages/auth/forder-password-page';
import { ConfirmPhone } from '@pages/auth/confirm-phone-page';
import { WaitingRestore } from '@pages/auth/waiting-restore-page';
import { SetNewPassword } from '@pages/auth/set-new-password-page';
import { MainLayout } from '@app/layouts/main-layout/main';
import { AfterRegistration } from '@pages/auth/after-registration-page';
import { AfterRegistrationTeacher } from '@pages/auth/after-registration-teacher';
import { RedirectsFromLogin } from './redirects-from-login';
import { LoginPage } from '@pages/auth/login-page';
import { RegisterPage } from '@pages/auth/register-page';
import { VerifyPage } from '@pages/auth/verify-page';
import { UnsubscribePage } from '@pages/auth/unsubscribe-page';

export const AuthRouterGroup = () => {
	return (
			<Routes>
				<Route element={<><Outlet/></>} >
					<Route path="/login/:referral?" element={<LoginPage />} />
					<Route path="/sign-up/:referral?" element={<RegisterPage role="student" />} />
					<Route path="/sign-up-teacher/:referral?" element={<RegisterPage role="teacher" />} />
					<Route path="/reset-password/:email/:token" element={<ResetPassword />} />
					<Route path="/forgot-password" element={<ForgetPasswordPage />} />
					<Route path="/confirm-phone" element={<ConfirmPhone />} />
					<Route path="/waiting-restore" element={<WaitingRestore />} />
					<Route path="/set-new-password" element={<SetNewPassword />} />
					<Route path="/verify-email/:token" element={<VerifyPage />} />
					<Route path="/unsubscribe/:token" element={<UnsubscribePage />} />
				</Route>
				<Route element={<MainLayout />}>
					<Route path="/waiting-confirm" element={<AfterRegistration />} />
					<Route path="/waiting-confirm-teacher" element={<AfterRegistrationTeacher />} />
				</Route>
				<Route path="*" element={<RedirectsFromLogin/>} />
			</Routes>
	)
}
